import * as React from 'react';
import { useSelector } from 'hooks/useSelector';
import {
  selectRptReportPages,
  selectRptReportPagesSaved,
} from 'store/remote/selectors';
import { MainDrawerParamList } from 'components/Navigation/types';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { PageNavigation } from './PageNavigation';
import { PageSwitch } from './PageSwitch';
import { selectOfflineOnly } from 'store/app/selectors';
import { TabOfflineScreen } from 'screens/TabScreen/TabOfflineScreen';
import { IsInHomeProvider } from 'hooks/isInHome';
import { doSetSidebar } from 'store/actions';
import { useDispatch } from 'react-redux';

const StackNavigator = createNativeStackNavigator<MainDrawerParamList>();

export const PageStackMobile: React.FC = () => {
  const dispatch = useDispatch();
  const reportPagesSaved = useSelector(selectRptReportPagesSaved);
  const reportPages = useSelector(selectRptReportPages);
  const offlineOnly = useSelector(selectOfflineOnly);

  React.useEffect(() => {
    dispatch(
      doSetSidebar({
        canBePinned: true,
        isPinned: true,
      }),
    );
  }, [dispatch]);

  if (offlineOnly) {
    return <TabOfflineScreen />;
  }

  return (
    <IsInHomeProvider value={true}>
      <StackNavigator.Navigator
        initialRouteName="Home"
        screenOptions={{
          animation: 'default',
          headerShown: false,
        }}
      >
        <StackNavigator.Screen
          name="Home"
          component={PageNavigation}
        ></StackNavigator.Screen>
        {reportPagesSaved.map((page) => (
          <StackNavigator.Screen
            key={page.key}
            name={page.key}
            component={PageSwitch}
            initialParams={page}
          />
        ))}
        {reportPages.map((page) => (
          <StackNavigator.Screen
            key={page.key}
            name={page.key}
            component={PageSwitch}
            initialParams={page}
          />
        ))}
      </StackNavigator.Navigator>
    </IsInHomeProvider>
  );
};
